// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React,{useRef} from 'react'
import { Feature, Image, Layer, Marker, Popup } from 'react-mapbox-gl'
import { connect, useDispatch, useSelector } from 'react-redux'
import onlineCameraDefault from 'assets/images/online-camera-default.png'
import onlineCameraHovered from 'assets/images/online-camera-hovered.png'
import offlineCameraDefault from 'assets/images/offline-camera-default.png'
import offlineCameraHovered from 'assets/images/offline-camera-hovered.png'
import CameraStatus from '../CameraStatus'
import { DOWNLOAD_TASK_TYPE } from '../../../constants'
import { ControlGroup, CameraControl, GpsTraceControl, FinderControl } from 'components/map-controller'
import { getRoadName } from '../../../api/devices'
import { OnlineStatus } from '../../../constants/device'

export const imageSources = [
  {
    id: 'online-camera-default',
    url: onlineCameraDefault
  },
  {
    id: 'online-camera-hovered',
    url: onlineCameraHovered
  },
  {
    id: 'offline-camera-default',
    url: offlineCameraDefault
  },
  {
    id: 'offline-camera-hovered',
    url: offlineCameraHovered
  }
]

class Cameras extends React.Component {
  previousEnteredFeatureId = -1

  handleMouseMove = e => {
    const { onCameraHover } = this.props
    if (e.features && e.features[0]) {
      const feature = e.features[0]
      if (feature.properties.id === this.previousEnteredFeatureId) {
        return
      }
      this.previousEnteredFeatureId = feature.properties.id
    }
    const camera = this.getCameraFromFeature(e)
    if (camera) {
      if (typeof onCameraHover !== 'function') {
        return
      }
      onCameraHover(camera)
    }
  }

  handleMouseLeave = e => {
    // const { onCameraHover } = this.props
    // if (typeof onCameraHover !== 'function') {
    //   return
    // }
    // onCameraHover(null)
    this.previousEnteredFeatureId = -1
  }

  handleLayerClick = e => {
    const { onCameraClick } = this.props
    const camera = this.getCameraFromFeature(e)
    if (camera) {
      onCameraClick(camera)
    }
  }

  getCameraFromFeature = e => {
    const { cameraList } = this.props
    let camera = null
    if (e.features && e.features[0]) {
      const feature = e.features[0]
      camera = cameraList.find(d => d.deviceID === feature.properties.deviceID)
    }
    return camera
  }

  renderMarkers = () => {
    const { cameraList, hoveredCamera, isShowCameras, selectedCamera } = this.props
    if (!selectedCamera) {
      return null
    }
    const selectedCameras = cameraList.filter(camera => selectedCamera === camera.deviceID)
    return selectedCameras.map(d => (
      <Marker
        key={d.deviceID}
        coordinates={[d.lon, d.lat]}
        style={{
          display: isShowCameras && !hoveredCamera ? 'block' : 'none'
        }}
        anchor='center'
      >
        <div className='selected-camera-marker' />
      </Marker>
    ))
  }

  handleCameraFinderSwitchClick = e => {
    const {
      editingPreTask,
      setCameraFinderVisible,
      setCameraFinderExpanded,
      isCameraFinderVisible,
      downloadMode
    } = this.props
    if (downloadMode === 'update' || editingPreTask.jobType !== DOWNLOAD_TASK_TYPE.DEVICE) {
      e.preventDefault()
      return
    }
    setCameraFinderVisible(!isCameraFinderVisible)
    if (!isCameraFinderVisible) {
      setCameraFinderExpanded(false)
    }
  }

  render () {
    const {
      cameraList = [],
      hoveredCamera,
      isShowCameras,
      isCameraFinderVisible,
      setCamerasShow,
      editingPreTask,
      isCameraFinderExpanded,
      setGPSTrackerVisible,
      isGPSTrackerVisible,
      downloadMode
    } = this.props
    const markers = this.renderMarkers()
    const isGPSTrackerEnable =
      editingPreTask.jobType !== DOWNLOAD_TASK_TYPE.GEOFENCE && editingPreTask.jobType !== DOWNLOAD_TASK_TYPE.ROAD
    const controlMarginRight = isCameraFinderExpanded ? 378 : 10
    return (
      <>
        {isShowCameras && hoveredCamera && (
          <Popup
            coordinates={[hoveredCamera.lon, hoveredCamera.lat]}
            style={{ padding: 0 }}
            anchor='bottom'
            offset={[0, -20]}
          >
            <CameraStatus camera={hoveredCamera} />
          </Popup>
        )}
        {markers}
        {/*{imageSources.map((source, index) => (*/}
        {/*  <Image {...source} key={index} />*/}
        {/*))}*/}
        <Layer
          type='symbol'
          source='point'
          layout={{
            'icon-image': ['get', 'icon-image'],
            'icon-size': 0.34,
            visibility: isShowCameras ? 'visible' : 'none',
            'icon-allow-overlap': true,
            'text-allow-overlap': true,
            'icon-ignore-placement': true,
            'symbol-z-order': 'source',
            'symbol-sort-key': 999
          }}
          onMouseMove={this.handleMouseMove}
          onMouseLeave={this.handleMouseLeave}
          onClick={this.handleLayerClick}
        >
          {cameraList.map((camera, index) => {
            const isHovered = hoveredCamera && hoveredCamera.deviceID === camera.deviceID
            const iconImage = `${(camera.onlineStatus === OnlineStatus.Online)? 'online' : 'offline'}-camera-${
              isHovered ? 'hovered' : 'default'
            }`
            return (
              <Feature
                properties={{ 'icon-image': iconImage, deviceID: camera.deviceID }}
                key={index}
                id={camera.deviceID}
                coordinates={[camera.lon, camera.lat]}
              />
            )
          })}
        </Layer>
      </>
    )
  }
}

Cameras = connect(
  ({ cameras, map, download, cameraFinder, gpsTrace }) => ({
    ...cameras,
    ...download,
    downloadMode: download.mode,
    isShowCameras:
      map.isShowCameras &&
      (download.editingPreTask.jobType === undefined || download.editingPreTask.jobType === DOWNLOAD_TASK_TYPE.DEVICE),
    isCameraFinderVisible: cameraFinder.visible,
    isGPSTrackerVisible: gpsTrace.isGPSTrackerVisible,
    isCameraFinderExpanded: cameraFinder.expanded
  }),
  ({ cameras, map, cameraFinder, gpsTrace }) => ({
    ...cameras,
    setCamerasShow: map.setCamerasShow,
    setCameraFinderVisible: cameraFinder.setVisible,
    setGPSTrackerVisible: gpsTrace.setGPSTrackerVisible,
    setCameraFinderExpanded: cameraFinder.setExpanded
  }),
  (stateProps, dispatchProps, ownProps) => {
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps
    }
  }
)(Cameras)

const Container = (props)=>{
  const {cameras:{uploadingCamera,hoveredCamera},gpsTrace:{isGPSTrackerVisible}} = useSelector(({cameras, gpsTrace})=>({cameras,gpsTrace}))
  const timeoutHandler = useRef(null)
  const {
    cameras:{updateHoveredCamera,updateSelectedCamera},
    gpsTrace:{fetchAndUpdateDeviceTrace, setActiveDevice}
  } = useDispatch()


  const onCameraHover = (camera) =>{
    if (camera) {
      if(camera.deviceID === hoveredCamera?.deviceID) return
      if (timeoutHandler.current) {
        clearTimeout(timeoutHandler.current)
      }
      //timeout used to hovering clustered cameras more smoothly
      timeoutHandler.current = setTimeout(async () => {
        const roadName = await getRoadName(camera.deviceID)
        camera.road = roadName
        updateHoveredCamera(camera)
      }, 200)
    }else if(camera === null){
      updateHoveredCamera(null)
    }
  }
  const getGPSTrace = async (camera)=>{
    updateSelectedCamera(camera.deviceID)
    if(isGPSTrackerVisible){
      await setActiveDevice(camera.deviceID)
      fetchAndUpdateDeviceTrace()
    }
  }
  const onCameraContextMenu = ()=>{}

  return (
    <Cameras
      selectedCameraId ={uploadingCamera}
      onCameraHover={onCameraHover}
      onCameraClick={getGPSTrace}
      onCameraContextMenu={onCameraContextMenu}
    />
  )
}
export {
  Cameras,
  Container as default,
}
